import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const PHASES = [
  {
    n: "01",
    title: "Assess & Design",
    items: [
      "Feasibility & business case",
      "Location & talent mapping",
      "Operating model blueprint",
      "Board sign-off pack",
    ],
  },
  {
    n: "02",
    title: "Structure & Compliance",
    items: [
      "Entity incorporation",
      "Tax, SEZ & transfer pricing",
      "Regulatory registrations",
      "Banking & treasury setup",
    ],
  },
  {
    n: "03",
    title: "Build & Hire",
    items: [
      "Leadership search",
      "Workspace & infrastructure",
      "Technology stack rollout",
      "Policy & process design",
    ],
  },
  {
    n: "04",
    title: "Operate & Scale",
    items: [
      "Finance & payroll operations",
      "Governance cadence & reporting",
      "Compliance calendar",
      "Scale playbooks",
    ],
  },
];

export default function Execution() {
  return (
    <section id="gcc-execution" className="border-b border-line">
      <div className="mx-auto max-w-7xl px-6 py-24 md:py-32">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/60">
            02 — GCC Execution
          </p>
          <h2
            className="mt-4 max-w-3xl font-serif text-4xl tracking-tight md:text-5xl"
            data-testid="execution-headline"
          >
            Four phases. One accountable partner.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-ink/70">
            A fixed engagement model that takes you from first feasibility
            question to a fully operating India GCC — itemised like a ledger,
            delivered like a promise.
          </p>
        </Reveal>
        <div className="mt-14" data-testid="execution-ledger">
          {PHASES.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.06}>
              <div
                className={`group grid grid-cols-1 gap-6 border-t border-line py-8 transition-colors duration-300 hover:bg-white md:grid-cols-12 md:py-10 ${
                  i === PHASES.length - 1 ? "border-b" : ""
                }`}
                data-testid={`phase-${p.n}`}
              >
                <div className="font-mono text-xs uppercase tracking-[0.25em] text-ink/40 md:col-span-2">
                  Phase {p.n}
                </div>
                <h3 className="font-serif text-2xl tracking-tight transition-colors duration-300 group-hover:text-gold md:col-span-4 md:text-3xl">
                  {p.title}
                </h3>
                <ul className="grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2 md:col-span-6">
                  {p.items.map((d) => (
                    <li
                      key={d}
                      className="flex items-start gap-2 text-sm leading-relaxed text-ink/70"
                    >
                      <ArrowUpRight className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} />
                      {d}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
